"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Class Utils
// Implements utility functions.
var Utils = /** @class */ (function () {
    function Utils() {
    }
    // ---
    // Description: Returns the width of the slide.
    // aspect_ratio: The desired aspect ratio (or 0 for dynamic calculation).
    // custom_width: The custom width.
    // ---
    Utils.prototype.getSlideWidth = function (aspect_ratio, custom_width) {
        aspect_ratio = aspect_ratio || 0;
        if (aspect_ratio == 0)
            return window.outerWidth;
        var width = custom_width; // ...
        return width;
    };
    // ---
    // Description: Returns the height of the slide.
    // aspect_ratio: The desired aspect ratio (or 0 for dynamic calculation).
    // custom_width: The custom width.
    // ---
    Utils.prototype.getSlideHeight = function (aspect_ratio, custom_width) {
        aspect_ratio = aspect_ratio || 0;
        if (aspect_ratio == 0)
            return window.outerHeight;
        var width = custom_width;
        var height = width / aspect_ratio;
        return height;
    };
    // ---
    // Description: Returns the current aspect ratio.
    // ---
    Utils.prototype.getCurrentAspectRatio = function () {
        var window_width = window.innerWidth;
        var window_height = window.innerHeight;
        var current_aspect_ratio = window_width / window_height;
        return current_aspect_ratio;
    };
    // ---
    // Description: Gets the relative width of an element, with respect to the
    // whole window.
    // element: Specifies the element to consider.
    // aspect_ratio: The desired aspect ratio (or 0 for dynamic calculation).
    // custom_width: The custom width.
    // ---
    Utils.prototype.getRelativeWidth = function (element_width, aspect_ratio, custom_width) {
        var window_width = aspect_ratio == 0 ? window.outerWidth : custom_width;
        var relative_width = element_width / window_width;
        return relative_width;
    };
    // ---
    // Description: Returns the integer representation of a character.
    // character: Specifies the character to convert.
    // ---
    Utils.prototype.toInt = function (character) {
        return 1 * character;
    };
    // ---
    // Description: Returns a 2-digit-representation of a number (e.g. "6"
    // becomes "06", but "11" will still be "11").
    // num: Specify the number.
    // ---
    Utils.prototype.toTwoDigits = function (num) {
        return ("0" + num).slice(-2);
    };
    // ---
    // Description: Switches the existence of a class of each element in a
    // specified list (ignores elements with class "ignore").
    // element_list: The list of elements.
    // class_name: The name of the class.
    // ---
    Utils.prototype.switchElementsClass = function (element_list, class_name) {
        for (var i = 0; i < element_list.length; i++) {
            if (element_list[i].classList.contains("ignore") == true)
                continue;
            if (element_list[i].classList.contains(class_name) == true)
                element_list[i].classList.remove(class_name);
            else
                element_list[i].classList.add(class_name);
        }
    };
    // ---
    // Description: Adds a class to an element if not already present
    // element_list: The list of elements.
    // class_name: The name of the class.
    // ---
    Utils.prototype.addElementsClass = function (element_list, class_name) {
        for (var i = 0; i < element_list.length; i++) {
            if (element_list[i].classList.length == 0 ||
                element_list[i].classList.contains(class_name) == false) {
                element_list[i].classList.add(class_name);
            }
        }
    };
    // ---
    // Description: Inverts the color attribute of all elements in the specified
    // list.
    // element_list: The list of elements.
    // low_light_mode: Specified whether colors should be inverted or reset.
    // ---
    Utils.prototype.invertElementsColor = function (element_list, low_light_mode) {
        low_light_mode = low_light_mode || false;
        for (var i = 0; i < element_list.length; i++) {
            // Continue if night mode is to be disabled
            if (low_light_mode == true) {
                element_list[i].style.color = "";
                continue;
            }
            // Invert color
            var color_rgb = getComputedStyle(element_list[i]).getPropertyValue("color");
            var color_hex = "#";
            var rgx = /\d+/g;
            var match;
            while ((match = rgx.exec(color_rgb)) != null) {
                var inverted = 255 - match[0];
                if (inverted < 16)
                    color_hex += "0";
                color_hex += inverted.toString(16);
            }
            element_list[i].style.color = color_hex;
        }
    };
    // ---
    // Description: Returns the font size in em for a specific CSS query
    // query: the CSS query
    // ---
    Utils.prototype.getEM = function (query) {
        return parseFloat(window.getComputedStyle(document.querySelectorAll(query)[0]).getPropertyValue("font-size")) / parseFloat(window.getComputedStyle(document.body).getPropertyValue("font-size"));
    };
    // ---
    // Description: Converts rem to pixel count
    // rem: the rem input
    // ---
    Utils.prototype.remToPixel = function (rem) {
        return parseFloat(window.getComputedStyle(document.body).getPropertyValue("font-size")) * rem;
    };
    // ---
    // Description: Applies a regex to keyboard input, only allowing specific keys
    // textbox: The textbox to filter.
    // inputFilter: Function returning the filtered input
    //              Example: function(value) {return /^\d*$/.test(value);}
    // Source: https://jsfiddle.net/emkey08/zgvtjc51
    // ---
    Utils.prototype.setInputFilter = function (textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
            textbox.addEventListener(event, function () {
                if (inputFilter(this.value)) {
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                }
                else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                }
            });
        });
    };
    // ---
    // Description: Creates an html element from a given input string
    // htmlstr: The html string
    // ---
    Utils.prototype.htmlParse = function (htmlstr) {
        var template = document.createElement("div");
        template.innerHTML = htmlstr;
        return template.firstElementChild;
    };
    // ---
    // Description: Insterts an html element at the start of another one
    // parent: The html element that gets modified
    // html: The new html element as string
    // ---
    Utils.prototype.prependHtmlString = function (parent, html) {
        var view = this.htmlParse(html);
        parent.insertBefore(view, parent.firstChild);
        return view;
    };
    // ---
    // Description: Inserts an html element at the end of another one
    // parent: The html element that gets modified
    // html: The new html element as string
    // ---
    Utils.prototype.appendHtmlString = function (parent, html) {
        var view = this.htmlParse(html);
        parent.appendChild(view);
        return view;
    };
    // ---
    // Description: Get the slide with the specified index
    // index: slide index
    // ---
    Utils.prototype.getSlide = function (index) {
        return window.rslidy.content.slideTransition.slides[index];
    };
    // ---
    // Description: True if an element is visible on screen
    // elm: the html element to check
    // ---
    Utils.prototype.checkVisible = function (elm) {
        var rect = elm.getBoundingClientRect();
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    };
    return Utils;
}());
exports.Utils = Utils;
